module.exports = __webpack_public_path__ + "img/l-4.63ea3c1d.jpg";